import { ChangeDetectionStrategy, Component } from '@angular/core';

import { routePaths } from '../app-route-paths';
import { AsideLink } from '../layouts/aside/aside.component';
import { MainComponent } from '../layouts/main/main.component';

const componentsRoutes = routePaths.components.children;

/** Components page. */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'sa-components',
  imports: [MainComponent],
  templateUrl: './components.component.html',
  styleUrls: ['./components.component.css'],
})
export class ComponentsComponent {
  /** Links. */
  protected readonly links: readonly AsideLink[] = [
    { path: componentsRoutes.table.url, title: 'Table' },
    { path: componentsRoutes.autocomplete.url, title: 'Autocomplete' },
    { path: componentsRoutes.overlay.url, title: 'Overlay' },
    { path: componentsRoutes.dialog.url, title: 'Dialog' },
    { path: componentsRoutes.snackbar.url, title: 'Snackbar' },
  ];
}
